import { PROPERTY_REPAIR } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case PROPERTY_REPAIR:
      return action.payload
    default:
      return state;
  }
}